import { validateEnumTranslations } from '../../safety_checks';

/**
 * Relance des essais (docs/to_implement/trial-relance-plan.md) — enums partagés backend /
 * admin. Les libellés servent aux écrans admin (liste des pros en essai, écran Relances).
 */

/** Voie déclarée par l'intention du wizard : `LES_DEUX` suit la voie Site. */
export enum TrialVoie {
  SITE = 'SITE',
  RESERVATION = 'RESERVATION',
}

export const TRANSLATE_KEY_TRIAL_VOIE = 'TRIAL_VOIE_';

export const TrialVoieTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_TRIAL_VOIE}${TrialVoie.SITE}`]: 'Site',
    [`${TRANSLATE_KEY_TRIAL_VOIE}${TrialVoie.RESERVATION}`]: 'Réservation',
  },
};

validateEnumTranslations(TrialVoie, TrialVoieTranslation, TRANSLATE_KEY_TRIAL_VOIE, true);

/** Cinq segments dérivés du trio présence × score × progression (plan §4). */
export enum TrialSegment {
  S1_FANTOME = 'S1_FANTOME',
  S2_DEBUTANT = 'S2_DEBUTANT',
  S3_EN_CONSTRUCTION = 'S3_EN_CONSTRUCTION',
  S4_PRET = 'S4_PRET',
  S5_BLOQUE = 'S5_BLOQUE',
}

export const TRANSLATE_KEY_TRIAL_SEGMENT = 'TRIAL_SEGMENT_';

export const TrialSegmentTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_TRIAL_SEGMENT}${TrialSegment.S1_FANTOME}`]: 'Fantôme',
    [`${TRANSLATE_KEY_TRIAL_SEGMENT}${TrialSegment.S2_DEBUTANT}`]: 'Débutant',
    [`${TRANSLATE_KEY_TRIAL_SEGMENT}${TrialSegment.S3_EN_CONSTRUCTION}`]: 'En construction',
    [`${TRANSLATE_KEY_TRIAL_SEGMENT}${TrialSegment.S4_PRET}`]: 'Prêt',
    [`${TRANSLATE_KEY_TRIAL_SEGMENT}${TrialSegment.S5_BLOQUE}`]: 'Bloqué',
  },
};

validateEnumTranslations(TrialSegment, TrialSegmentTranslation, TRANSLATE_KEY_TRIAL_SEGMENT, true);

/** Moments du calendrier J0 → J7 (plan §5.1). J4 est humain, hors moteur. */
export enum TrialRelanceMoment {
  J0_SMS = 'J0_SMS',
  J1 = 'J1',
  J2 = 'J2',
  J2_SMS = 'J2_SMS',
  J3 = 'J3',
  J5 = 'J5',
  J6 = 'J6',
  J6_SMS = 'J6_SMS',
  J7 = 'J7',
}

export const TRANSLATE_KEY_TRIAL_RELANCE_MOMENT = 'TRIAL_RELANCE_MOMENT_';

export const TrialRelanceMomentTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_TRIAL_RELANCE_MOMENT}${TrialRelanceMoment.J0_SMS}`]: 'J0 + 4h · SMS',
    [`${TRANSLATE_KEY_TRIAL_RELANCE_MOMENT}${TrialRelanceMoment.J1}`]: 'J1 · Prochaine étape',
    [`${TRANSLATE_KEY_TRIAL_RELANCE_MOMENT}${TrialRelanceMoment.J2}`]: 'J2 · Push',
    [`${TRANSLATE_KEY_TRIAL_RELANCE_MOMENT}${TrialRelanceMoment.J2_SMS}`]: 'J2 · SMS Fantôme',
    [`${TRANSLATE_KEY_TRIAL_RELANCE_MOMENT}${TrialRelanceMoment.J3}`]: 'J3 · Ce que vous avez construit',
    [`${TRANSLATE_KEY_TRIAL_RELANCE_MOMENT}${TrialRelanceMoment.J5}`]: 'J5 · Il reste 2 jours',
    [`${TRANSLATE_KEY_TRIAL_RELANCE_MOMENT}${TrialRelanceMoment.J6}`]: 'J6 · Veille de fin (push)',
    [`${TRANSLATE_KEY_TRIAL_RELANCE_MOMENT}${TrialRelanceMoment.J6_SMS}`]: 'J6 · Veille de fin (SMS)',
    [`${TRANSLATE_KEY_TRIAL_RELANCE_MOMENT}${TrialRelanceMoment.J7}`]: 'J7 · Fin d’essai',
  },
};

validateEnumTranslations(TrialRelanceMoment, TrialRelanceMomentTranslation, TRANSLATE_KEY_TRIAL_RELANCE_MOMENT, true);
